import React, { useState, useContext, useEffect } from "react";
import Footer_v1 from "./global-components/footer";
import NavbarV2 from "./global-components/navbar-v2";
import { AppContext } from "../AppContext";

const Webstories = () => {
  const { webStories } = useContext(AppContext);
  const [showPopup, setShowPopup] = useState(false);
  const [currentStoryIndex, setCurrentStoryIndex] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleOpenPopup = (index) => {
    setCurrentStoryIndex(index);
    setCurrentImageIndex(0);
    setShowPopup(true);
  };

  const handleClosePopup = () => setShowPopup(false);

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) => {
      const images = JSON.parse(webStories[currentStoryIndex]?.images || "[]");
      return prev === 0 ? images.length - 1 : prev - 1;
    });
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) => {
      const images = JSON.parse(webStories[currentStoryIndex]?.images || "[]");
      return prev === images.length - 1 ? 0 : prev + 1;
    });
  };

  const extractTextArray = (head_lines) => {
    const regex = /<li>(.*?)<\/li>/g;
    const matches = [...head_lines.matchAll(regex)];
    return matches.map((m) => m[1]);
  };

  // ✅ Auto-play every 3 seconds
  useEffect(() => {
    let interval;
    if (showPopup) {
      interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => {
          const images = JSON.parse(
            webStories[currentStoryIndex]?.images || "[]"
          );
          return (prevIndex + 1) % images.length;
        });
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [showPopup, currentStoryIndex, webStories]);

  return (
    <>
      <NavbarV2 />
      <div className="tranding-area pd-top-50 pd-bottom-50 go-top">
        <div className="container">
          <div className="section-title style-two">
            <div className="row">
              <div className="col-md-3">
                <h2 className="title">Visual Stories</h2>
              </div>
            </div>
          </div>
          <div className="row">
            {webStories.map((story, index) => {
              const imageArray = JSON.parse(story.images || "[]");
              const firstImage =
                "https://hondaapi.clientcoding.com/" + imageArray[0];
              return (
                <div
                  className="col-lg-3 col-sm-6 mb-4"
                  key={story.id}
                  onClick={() => handleOpenPopup(index)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="single-post-wrap style-overlay">
                    <div className="thumb">
                      <img
                        src={firstImage}
                        alt="story"
                        style={{
                          maxWidth: "100%",
                          objectFit: "cover",
                          height: "480px",
                        }}
                      />
                    </div>
                    <div className="details mt-2">
                      <h6 className="title">
                        {extractTextArray(story.head_lines)[0]}
                      </h6>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Popup */}
      {showPopup && (
        <div
          className="story-popup"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgb(0, 0, 0)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="story-content"
            style={{
              position: "relative",
              width: "350px",
              maxWidth: "95%",
              borderRadius: "10px",
              overflow: "hidden",
              backgroundColor: "#000",
            }}
          >
            {/* ✅ Progress Bars */}
            <div
              style={{
                display: "flex",
                position: "absolute",
                top: "0px",
                left: "0px",
                right: "0px",
                padding: "10px",
                gap: "5px",
                zIndex: 2,
              }}
            >
              {JSON.parse(webStories[currentStoryIndex]?.images || "[]").map(
                (_, i) => (
                  <div
                    key={i}
                    style={{
                      flex: 1,
                      height: "3px",
                      backgroundColor: "#444",
                      borderRadius: "2px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        height: "100%",
                        width:
                          i < currentImageIndex
                            ? "100%"
                            : i === currentImageIndex
                            ? "100%"
                            : "0%",
                        backgroundColor: "#fff",
                        animation:
                          i === currentImageIndex
                            ? "progressAnimation 3s linear forwards"
                            : "none",
                      }}
                    />
                  </div>
                )
              )}
            </div>

            {/* ✅ Image */}
            <img
              src={
                "https://hondaapi.clientcoding.com/" +
                JSON.parse(webStories[currentStoryIndex]?.images || "[]")[
                  currentImageIndex
                ]
              }
              alt="story-slide"
              style={{
                width: "100%",
                height: "600px",
                objectFit: "cover",
              }}
            />

            {/* ✅ Text */}
            <div
              className="story-text"
              style={{
                position: "absolute",
                bottom: "0px",
                left: "0px",
                right: "0px",
                padding: "10px",
                background: "rgb(0 0 0 / 68%)",
                color: "#fff",
                fontSize: "24px",
              }}
            >
              {
                extractTextArray(webStories[currentStoryIndex]?.head_lines)[
                  currentImageIndex
                ]
              }
            </div>

            {/* Controls */}
            <button
              onClick={handlePrevImage}
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                background: "rgb(0 78 188 / 73%)",
                borderRadius: "50%",
                border: "none",
                color: "#fff",
                width: "40px",
                height: "40px",
                cursor: "pointer",
              }}
            >
              &#8249;
            </button>
            <button
              onClick={handleNextImage}
              style={{
                position: "absolute",
                top: "50%",
                right: "10px",
                transform: "translateY(-50%)",
                background: "rgb(0 78 188 / 73%)",
                color: "#fff",
                borderRadius: "50%",
                border: "none",
                width: "40px",
                height: "40px",
                cursor: "pointer",
              }}
            >
              &#8250;
            </button>
            <button
              onClick={handleClosePopup}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "rgb(0 78 188 / 73%)",
                color: "#fff",
                borderRadius: "50%",
                border: "none",
                width: "35px",
                height: "35px",
                cursor: "pointer",
                fontSize: "20px",
              }}
            >
              ✕
            </button>
          </div>
        </div>
      )}

      <Footer_v1 />

      {/* ✅ Add animation keyframes */}
      <style>
        {`
          @keyframes progressAnimation {
            from { width: 0%; }
            to { width: 100%; }
          }
        `}
      </style>
    </>
  );
};

export default Webstories;
